export const NO_REPLY_EMAIL_ADDRESS = 'no-reply@mycreditportal.ca';
export const ALLOWED_ATTACHMENTS_SIZE = 15; //allowed size for attachments in MB
